export default __webpack_public_path__ + "static/media/lock.746bca3c.svg";